import { Component } from "react";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { getPowerConnectionDetails_action, } from "../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/power_connection_action/power_connection_action";
import { updatePowerApproval_action } from "../../../../actions/admin_module_action/manual_forms_admin_action/power_approval_action/power_approval_action";
import { toastError, toastSuccess } from "../../../../utils/constants";
import Modal from "react-modal";


class PowerReqApproval extends Component {

    //Initialize Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            powerFormId: "",
            PowerConnectionList: [],
            CGST: "",
            SGST: "",
            Remark: "",
            Is_Agree: "",
            isOpen: false,
            isRejectOpen: false,
            remark: ""
        }
        this.getPowerConnectionDetails = this.getPowerConnectionDetails.bind(this)
        this.calculateTotals = this.calculateTotals.bind(this)
        this.toggleDisapprovalModal = this.toggleDisapprovalModal.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.onBackClick = this.onBackClick.bind(this)
        this.updatePowerApproval = this.updatePowerApproval.bind(this)
    }

    componentDidMount() {
        this.setState({
            powerFormId: this.props.location.state != null && this.props.location.state.FormID ? this.props.location.state.FormID : '',
        })
        this.getPowerConnectionDetails()
    }

    getPowerConnectionDetails() {
        this.setState({ isLoading: true })
        this.props
            .getPowerConnectionDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        this.setState({
                            PowerConnectionList: data.data,
                            CGST: data.data[0]['CGST'],
                            SGST: data.data[0]['SGST'],
                            Remark: data.data[0]['Remark'],
                            Is_Agree: data.data[0]['Is_Agree']
                        })
                        console.log("data.data[0]['Is_Agree']", data.data[0]['Is_Agree'])
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    calculateTotals() {
        try {
            const { PowerConnectionList } = this.state
            let totalAmount = 0
            PowerConnectionList.forEach((data) => {
                totalAmount += Number(data.Amount)
            });
            return {
                totalAmount,
            };

        } catch (e) {
            console.log('exception : ', e);
        }

    }

    // Toggle ApprovaL Modal
    toggleModal() {
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
    }

    // Toggle Disapproval Modal
    toggleDisapprovalModal() {
        const { isRejectOpen } = this.state
        this.setState({ isRejectOpen: !isRejectOpen })
    }

    // On Back Click
    onBackClick() {
        this.props.navigate('/powerreqadmin')
    }

    // Update Approval Fascia Form
    updatePowerApproval(isApproved) {
        const { remark, powerFormId } = this.state
        if (isApproved == false ? remark != "" ? true : false : true) {
            console.log("testetetetet")
            this.setState({ isLoading: true })
            this.props.updatePowerApproval_action(isApproved, remark, powerFormId)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        toastSuccess('Power Form Approval Updated')
                        setTimeout(() => {
                            this.props.navigate('/powerreqadmin')
                        }, 1000);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError('Please Enter Remark')
        }
    }

    render() {
        const { isLoading, PowerConnectionList, CGST, SGST, isOpen, isRejectOpen, remark } = this.state
        const { totalAmount } = this.calculateTotals()
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <AdminDrawer />
                <>
                    <div className="main-content with-dr-container com-height p-2">
                        <div className="">
                            <div className="row">

                            </div>
                            <div className="row">
                                <div className="col-xl-12 p-0">
                                    <div className=" pt-1">
                                        <div className="card-header p-2 pt-3 pb-3">
                                            <h3 className="card-title" style={{ fontSize: 15 }}>
                                                Power Request Approve
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content mt-0 p-1 with-dr-container" >
                        <div className="row m-2">
                            <div className="table-responsive">
                                <hr className="mt-2" />
                                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                    <thead>
                                        <tr>
                                            <th>Description of Services</th>
                                            <th className="text-center">Rates (INR)</th>
                                            <th className="text-center"> Quantity</th>
                                            <th className="text-center">Amount (INR)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            PowerConnectionList.length > 0 && PowerConnectionList.map((data) => (
                                                <tr key={Math.random()}>
                                                    <td>{data.Description}</td>
                                                    <td className="text-center">{data.Rates}</td>
                                                    <td>
                                                        <input type="text" className="form-control"
                                                            value={data.Quantity} disabled
                                                        />

                                                    </td>
                                                    <td className="text-center">{data.Amount}</td>
                                                </tr>
                                            ))
                                        }

                                        <tr>
                                            <td />
                                            <td />
                                            <td className="text-center">
                                                <b>Total</b>
                                            </td>
                                            <td className="text-center">
                                                <b>{totalAmount}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td />
                                            <td />
                                            <td className="text-center">
                                                <b>CGST @ {CGST}%</b>
                                            </td>
                                            <td className="text-center">
                                                <b>{(CGST / 100) * totalAmount}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td />
                                            <td />
                                            <td className="text-center">
                                                <b>SGST @ {SGST}%</b>
                                            </td>
                                            <td className="text-center">
                                                <b>{(SGST / 100) * totalAmount}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td />
                                            <td />
                                            <td className="text-center">
                                                <b>Grand Total</b>
                                            </td>
                                            <td className="text-center">
                                                <b>{
                                                    (CGST / 100) * totalAmount + (SGST / 100) * totalAmount + totalAmount
                                                }</b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                        <div className="btn-group w-auto">
                            <button
                                className="form-control btn-primary"
                                onClick={(e) => this.toggleModal()}
                                disabled={PowerConnectionList.length > 0 && PowerConnectionList[0]['StatusName'] == 'Approved' ? true : false}
                            >
                                Approve
                            </button>
                            <button
                                className="form-control btn-primary ml-2"
                                onClick={(e) => this.toggleDisapprovalModal()}
                                disabled={PowerConnectionList.length > 0 && PowerConnectionList[0]['StatusName'] == 'Approved' ? true : false}
                            >
                                Disapproval
                            </button>
                            <button
                                className="form-control btn-primary ml-2"
                                onClick={(e) => this.onBackClick()}
                            >
                                Back
                            </button>
                        </div>

                    </div>
                    <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header p-2">
                                    <h5 class="modal-title modal_title_text text-danger">Confirm</h5>
                                    <button type="button " class="close pop-close" data-dismiss="modal"
                                        onClick={() => this.setState({ isOpen: false })}
                                    ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="pop_label">Do you really want to Approve ?</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button type="button" class="btn btn-del-pop"
                                            onClick={(e) => this.updatePowerApproval(true)}
                                        >Yes</button>
                                        <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                            onClick={() => this.setState({ isOpen: false })}
                                        >No</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={isRejectOpen} onRequestClose={() => this.setState({ isRejectOpen: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header p-2">
                                    <h5 class="modal-title modal_title_text text-danger">Confirm</h5>
                                    <button type="button " class="close pop-close" data-dismiss="modal"
                                        onClick={() => this.setState({ isRejectOpen: false })}
                                    ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {/* <p class="pop_label">Do you really want to Approve ?</p> */}
                                            <label htmlFor="validationCustom03">Remark</label>
                                            <textarea className="form-control"
                                                type="text"
                                                placeholder="Please Enter Remark...."
                                                value={remark}
                                                onChange={(e) => this.setState({ remark: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button type="button" class="btn btn-del-pop"
                                            onClick={(e) => this.updatePowerApproval(false)}
                                        >Yes</button>
                                        <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                            onClick={() => this.setState({ isRejectOpen: false })}
                                        >No</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal>
                </>


            </>
        )
    }
}
export default withRouter(connect(null, {
    getPowerConnectionDetails_action, getPowerConnectionDetails_action,
    updatePowerApproval_action
})(PowerReqApproval))